import { buildGraphqlQuery } from '@ztechapps/common.utils'

export const queries = buildGraphqlQuery('Blog', `_id updatedAt cover title summary remarks tags`)
